import { useCustomSnackbars } from "components/snackbars/useCustomSnackbars";
import { useIdentity } from "contexts/identity-context";
import * as QueryKeys from "data";
import { DemoConfiguration } from "data/models";
import { fetchDemos } from "data/queries-common";
import { DataDemos } from "pages/geoscape-demos/demo-page/demos-page";
import { useQuery } from "@tanstack/react-query";
import { Route } from "react-router";
import { resolveIdentityId } from "utils/identity";
import { useEffect } from "react";
import { Alert, AlertTitle } from "@/components/ui/alert";
import { TriangleAlert } from "lucide-react";
import { Spinner } from "@/components/ui/spinner";

import { StandardPageLayout } from "@/components/layouts/standard-page-layout";

export const DemoRoutes = ({ component, ...rest }: any) => {
  const [identityState] = useIdentity();

  const identityId = resolveIdentityId(identityState);

  const { enqueueQueryFailed } = useCustomSnackbars();

  const demosQuery = useQuery({
    queryKey: [QueryKeys.demosKey, identityId],
    queryFn: () => fetchDemos(),
  });

  useEffect(() => {
    if (demosQuery.isError) {
      enqueueQueryFailed(demosQuery.error.toString());
    }
  }, [demosQuery.isError]);

  const getDemoByPath = (path: string) => {
    return DataDemos.find((item) => item.path === path);
  };

  const hasAccess = (path: string, demosAccessList: DemoConfiguration[]) => {
    return demosAccessList.find((item) => item.id === getDemoByPath(path)?.id);
  };
  const Component = component;
  return (
    <Route
      {...rest}
      render={({ location }) =>
        demosQuery.isSuccess ? (
          hasAccess(rest.path, demosQuery.data) ? (
            <StandardPageLayout>
              <Component />
            </StandardPageLayout>
          ) : (
            <StandardPageLayout>
              <ErrorMessage />
            </StandardPageLayout>
          )
        ) : (
          <div className="flex h-full w-full items-center justify-center">
            <Spinner />
          </div>
        )
      }
    />
  );
};

const ErrorMessage = () => {
  return (
    <div className="flex h-full w-full items-center justify-center">
      <Alert variant="warning" className="w-fit">
        <TriangleAlert />
        <AlertTitle>
          You don't have permission to view this demo. Please contact support.
        </AlertTitle>
      </Alert>
    </div>
  );
};
